module.exports = __webpack_public_path__ + "static/media/macaroni.754810d6.png";